import { BookingOptionsCard } from './BookingOptionsCard'

import { Physician } from '@/src/interfaces'

interface BookingOptionsProps {
  physician: Physician
  className?: string
  showOnlineBooking?: boolean
  showPhoneBooking?: boolean
  showAllOptions?: boolean
  helpText?: boolean
  isRequestAppointmentModal?: boolean
}

export const BookingOptions = ({
  physician,
  showOnlineBooking,
  showPhoneBooking,
  showAllOptions,
  helpText,
  isRequestAppointmentModal,
}: BookingOptionsProps) => {
  const bookingOptions = []

  const shouldShowOnline = showOnlineBooking ?? showAllOptions
  const shouldShowPhone = showPhoneBooking ?? showAllOptions

  if (shouldShowOnline && physician.booking_url) {
    bookingOptions.push({
      type: 'online' as const,
      value: physician.booking_url,
    })
  }

  if (shouldShowPhone && physician.phone) {
    bookingOptions.push({
      type: 'phone' as const,
      value: physician.phone,
    })
  }

  if (bookingOptions.length === 0) return null

  return (
    <div className={`flex flex-col md:flex-row justify-between gap-4`}>
      {bookingOptions.map((option, index) => (
        <BookingOptionsCard
          key={option.type}
          bookingOption={option}
          helpText={helpText}
          physician={physician}
          isRequestAppointmentModal={isRequestAppointmentModal}
          position={(index + 1).toString()}
        />
      ))}
    </div>
  )
}
